import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { useShop } from '@/contexts/ShopContext';
import { api } from '@/lib/api';
import { ownerPath } from '@/lib/hosts';

export interface ServerNotification {
  id: number;
  type: string;
  title: string;
  body: string | null;
  data: { target?: string; public_order_id?: string; overdue_count?: number } | null;
  is_read: boolean;
  created_at: string;
}
export function notificationTarget(notification: ServerNotification) {
  return notification.type === 'public_order.created' && notification.data?.public_order_id
    ? ownerPath(`/commerce/orders/${notification.data.public_order_id}`)
    : notification.data?.target;
}
export function useServerNotifications(poll: number | false = false) {
  const { user } = useAuth();
  const { currentShop } = useShop();
  return useQuery({
    queryKey: ['notifications', 'header', user?.id, currentShop?.id],
    queryFn: () => api.get<ServerNotification[]>('/notifications?limit=20'),
    enabled: Boolean(user?.id && currentShop?.id),
    staleTime: 15_000,
    refetchInterval: poll,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });
}
